// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rbVZmTrjrS9TIMSHeU9z4g\\=\\={margin-top:-4px}", "",{"version":3,"sources":["webpack://./src/pages/DeliveryDashboard/components/DashboardStatisticsBannerMobile/DashboardStatisticsBannerMobile.module.scss"],"names":[],"mappings":"AAAA,4BACI,eAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"newBadge": "rbVZmTrjrS9TIMSHeU9z4g=="
};
export default ___CSS_LOADER_EXPORT___;
